import { CuadroSalidaA16Dto } from "./CuadroSalidaA16Dto";
import { CuadroSalidaA17Dto } from "./CuadroSalidaA17Dto";
import { CuadroSalidaA18Dto } from "./CuadroSalidaA18Dto";
import { CuadroSalidaA19Dto } from "./CuadroSalidaA19Dto";
import { CuadroSalidaA1Dto } from "./CuadroSalidaA1Dto";
import { CuadroSalidaA2Dto } from "./CuadroSalidaA2Dto";
import { CuadroSalidaA5Dto } from "./CuadroSalidaA5Dto";

export class RespuestaCuadrosSalidaChvDto {
  formato: any;
  data: any;
}
